import { Datasource } from '@app/features/core/hooks/use-current-user'

export const datasourceLabel = (datasource: Datasource) =>
  `${datasource.username}@${datasource.host}:${datasource.port}/${datasource.database}`
